import { render, staticRenderFns } from "./justEatRating.vue?vue&type=template&id=5ea739e0&scoped=true"
import script from "./justEatRating.vue?vue&type=script&lang=js"
export * from "./justEatRating.vue?vue&type=script&lang=js"
import style0 from "./justEatRating.vue?vue&type=style&index=0&id=5ea739e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea739e0",
  null
  
)

export default component.exports